// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AssemblyJig } from './assembly-jig';
import { OrderLineDetail } from './order-line-detail';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AssemblySchedule extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get displayName() {
        if (this.orderLineDetail && this.orderLineDetail.orderLine && this.orderLineDetail.orderLine.order && this.orderLineDetail.orderLine.order.dealer) {
            return `${this.orderLineDetail.vIN} --- ${this.orderLineDetail.orderLine.partNumber} - ${this.orderLineDetail.orderLine.order.dealer.companyName}`;
        } else return '';
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  buildDate!: Date;
  completed?: Date;
  completedBy?: string;
  created!: Date;
  createdBy?: string;
  jigId!: number;
  orderLineDetailId!: number;
  jig!: AssemblyJig;
  orderLineDetail!: OrderLineDetail;
}

